import { switcher } from '../utils';
import { ACTIONS } from '../../const';
import { wordCompressor } from '../../word_compressor';

export default switcher(
    {},
    {
        [ACTIONS.ADD_WORD_DATA](state, action) {
            const { data } = action;
            // recursively convert everything to immutable data
            return {
                ...state,
                [action.uri]: wordCompressor(data),
            };
        },
    }
);



// WEBPACK FOOTER //
// ./src/reducers/content/word_data.js